import { translate } from '@vimeo/i18n-runtime';

export const T = {
  AllowViewerComments: translate('Allow viewer comments'),
  Cancel: translate('Cancel'),
  ConfirmDelete: translate('Are you sure you want to delete this comment?'),
  CopyLink: translate('Copy link to comment'),
  Delete: translate('Delete'),
  DeleteComment: translate('Delete comment'),
  EditComment: translate('Edit comment'),
  Edit: translate('Edit'),
  InputPlaceholder: translate('Add a comment'),
  Newest: translate('Newest'),
  NoCommentsYet: translate('No comments yet'),
  NoComments: translate('No comments'),
  NoCollaboratorsComment: translate('No comments from collaborators'),
  NoCollaboratorsCommentYet: translate('No comments from collaborators yet'),
  NoViewersCommentYet: translate('No comments from viewers yet'),
  NoCommentsAllowed: translate('Comments are turned off'),
  Notifications: translate('Notifications'),
  DownloadCommentsAs: translate('Download as...'),
  Oldest: translate('Oldest'),
  Reply: translate('Reply'),
  RepliesToggle: (replyCount: number) =>
    translate({
      singular: '{replyCount} reply',
      plural: '{replyCount} replies',
      count: replyCount,
      replacements: {
        replyCount: replyCount,
      },
    }),
  Report: translate('Report comment'),
  SaveEdit: translate('Save'),
  Settings: translate('Settings'),
  SortBy: translate('Sort by:'),
  Staff: translate('Staff'),
  SubmitComment: translate('Post'),
  TimeCode: translate('By timecode'),
  Title: translate('Comments'),
  CommentsLoadingError: translate('Unable to load comments'),
  PostCommentError: translate('Unable to post comment'),
  PostReplyError: translate('Unable to post reply'),
  EditCommentError: translate('Unable to save comment'),
  Alum: translate('Alum'),
  AllComments: translate('All comments'),
  CollaboratorComments: translate('Collaborator comments'),
  ViewerComments: translate('Viewer comments'),
  Download: translate('Download'),
  SelectListToDownload: translate('Select list to download:'),
  DownloadCommentsAsCsv: translate('Download comments as CSV'),
  DownloadLimit: translate(
    'Downloads are limited to the most recent 2,000 viewer and 2,000 collaborator comments',
  ),
  DeletedComment: translate('This comment was deleted.'),
  DifferentSearch: translate('Try a different search'),
  Resolved: translate('Resolved'),
  Edited: translate('edited'),
  ShowFrom: translate('Show from'),
  Everyone: translate('Everyone'),
  OnlyFromTeam: translate('Only from team'),
  OnlyGuests: translate('Only guests'),
  MentionsAndReplies: translate('Mentions and replies'),
  Unread: translate('Unread'),
  HideResolvedComments: translate('Hide resolved comments'),
  ShowResolvedComments: translate('Show resolved comments'),
  ViewersCanNotPostNewComments: translate("Viewers can't post new comments"),
  AllowComments: translate('Allow comments'),
  NoMatchingResults: translate('No matching results'),
  ClearFilters: translate('Clear filters'),
  LinkCopied: translate('Link copied'),
  Filter: translate('Filter'),
  Sort: translate('Sort'),
  MarkAsResolved: translate('Mark as resolved'),
  ReOpen: translate('Re-open'),
  MarkAllAsRead: translate('Mark all as read'),
};
